module.exports = __webpack_public_path__ + "static/media/mess4.70b17e23.png";